import Highlight from './highlight/highlight';
import Selection from './selection';
import { handleMouseEvent } from './mouseEventHandler';
import { detectSelectionType, normalizeSelectionFactory } from './utils';
export { handleMouseEvent, Highlight, Selection, detectSelectionType, normalizeSelectionFactory };


//////////////////
// WEBPACK FOOTER
// ./node_modules/handsontable/es/selection/index.js
// module id = 494
// module chunks = 0